(() => {
  const launcherSelector = 'gty-whatsapp-chat-button';
  const protectedSelector = 'h1, h2, h3, button, summary, input, select, textarea, .button';
  let frame;

  const overlaps = (first, second, margin = 8) => !(
    first.right + margin < second.left
    || first.left - margin > second.right
    || first.bottom + margin < second.top
    || first.top - margin > second.bottom
  );

  const updateLauncher = () => {
    frame = null;
    const launcher = document.querySelector(launcherSelector);
    if (!launcher || window.innerWidth >= 750) return;

    const launcherSize = 48;
    const launcherRect = {
      left: window.innerWidth - launcherSize - 12,
      right: window.innerWidth - 12,
      top: window.innerHeight - launcherSize - 16,
      bottom: window.innerHeight - 16,
    };

    const isOverProtectedContent = Array.from(document.querySelectorAll(protectedSelector)).some((element) => {
      if (launcher.contains(element) || element.closest('[hidden], [aria-hidden="true"]')) return false;
      const style = getComputedStyle(element);
      if (style.display === 'none' || style.visibility === 'hidden') return false;
      const rect = element.getBoundingClientRect();
      if (rect.bottom <= 0 || rect.top >= window.innerHeight || rect.width === 0 || rect.height === 0) return false;
      return overlaps(launcherRect, rect);
    });

    launcher.classList.toggle('home-whatsapp--avoids-content', isOverProtectedContent);
  };

  const queueUpdate = () => {
    if (frame) return;
    frame = requestAnimationFrame(updateLauncher);
  };

  document.addEventListener('DOMContentLoaded', () => {
    queueUpdate();
    const observer = new MutationObserver(queueUpdate);
    observer.observe(document.body, { childList: true, subtree: true });
    window.setTimeout(() => observer.disconnect(), 15000);
  });
  window.addEventListener('scroll', queueUpdate, { passive: true });
  window.addEventListener('resize', queueUpdate, { passive: true });
})();
